import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=15beb85e&scoped=true&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15beb85e",
  null
  
)

export default component.exports